import Api from '../../../../shared/Api';
import { ApproveImagesByCustomer } from '../../../../shared/Features';

class OrderFilmApi {
    static getOrderText(orderId: number): any {
        return new Api().get(`/views/orders/${orderId}/copy`);
    }

    static getAvailableCopywriters(orderId: number): Promise<any> {
        return new Api().get(`/views/orders/${orderId}/copy/copywriters`)
    }

    static setTextAsDelivered(id: number): Promise<string> {
        return new Api().put(`/views/orders/${id}/copy/set-as-delivered`, {});
    }

    static setTextAsNotDelivered(id: number): Promise<string> {
        return new Api().put(`/views/orders/${id}/copy/set-as-not-delivered`, {});
    }

    static setCopywriterOnOrder(orderId: number, copywriterId: number): Promise<number> {
        return new Api().put(`/views/orders/${orderId}/copy/copywriter/${copywriterId}`, {});
    }
}

export default OrderFilmApi;
